/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationResult {
    getFixupPrototypeFunction() { return BillingAggregationResult.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationResult>): BillingAggregationResult {
        let obj = Object.assign(new BillingAggregationResult(), model);
        BillingAggregationResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationResult>): BillingAggregationResult {
        if (!model) return null;
        return BillingAggregationResult.newInstance(<BillingAggregationResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationResult) {
        if (!obj) return;

        models.BillingAggregationResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationResult): boolean {
        Object.setPrototypeOf(obj, BillingAggregationResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.value === undefined) {
            this.value = 0;
        }
        if (this.identity) {
            models.BillingLineItemIdentityPlus.fixupPrototype(this.identity);
        }
    }

    /**
     * Identity of the result group
     */
    identity: models.BillingLineItemIdentityPlus;

    /**
     * Result of aggregation
     */
    value: number;

}
